import { useContext } from 'react';
import cx from 'classnames';

import UnityIdContext from '../';
import UserInfo from '../UserInfo';

import { CSS_SELECTOR_FOR_SDK } from '../constants';

import styles from './index.styl';

export default function Control() {
  const { userInfo } = useContext(UnityIdContext);

  if (userInfo) return <UserInfo userInfo={userInfo} />;

  return (
    <div className={cx('unityIdControl', userInfo && styles._hasUserInfo)}>
      {userInfo && <UserInfo userInfo={userInfo} />}
      <div className={cx(styles.sberSdk, CSS_SELECTOR_FOR_SDK)} />
    </div>
  );
}
